(function () {
  function cfg() {
    return window.ADO_HEADER_OVERLAY || null;
  }

  function isDesktop() {
    return window.innerWidth >= 990;
  }

  function shouldEnable(c) {
    return (isDesktop() && c.enableDesktop) || (!isDesktop() && c.enableMobile);
  }

  function setClasses(on, scrolled, hideAccount) {
    var html = document.documentElement;
    var body = document.body;

    var add = function (el, cls) { if (el) el.classList.add(cls); };
    var rem = function (el, cls) { if (el) el.classList.remove(cls); };

    if (on) { add(html, "ado-header-overlay-on"); add(body, "ado-header-overlay-on"); }
    else { rem(html, "ado-header-overlay-on"); rem(body, "ado-header-overlay-on"); }

    if (scrolled) { add(html, "ado-header-scrolled"); add(body, "ado-header-scrolled"); }
    else { rem(html, "ado-header-scrolled"); rem(body, "ado-header-scrolled"); }

    if (hideAccount) { add(html, "ado-hide-account-icon"); add(body, "ado-hide-account-icon"); }
    else { rem(html, "ado-hide-account-icon"); rem(body, "ado-hide-account-icon"); }
  }

  function apply() {
    var c = cfg();
    if (!c) return setClasses(false, false, false);

    if (!shouldEnable(c)) return setClasses(false, false, false);

    var y = typeof c.scrollY === "number" ? c.scrollY : 20;
    var scrolled = window.scrollY > y;

    setClasses(true, scrolled, !!c.hideAccountIconHome);

    // CSS vars (por si el theme reescribe cosas)
    var html = document.documentElement;
    html.style.setProperty("--ado-header-text", c.textColor || "#FFFFFF");
    html.style.setProperty("--ado-header-text-scrolled", c.textColorScrolled || "#1B2B2A");
    html.style.setProperty("--ado-header-bg-scrolled", c.bgColorScrolled || "#FFFFFF");
    html.style.setProperty("--ado-header-z", String(c.zIndex || 9999));
    html.style.setProperty("--header-height", "0px");
  }

  if (!window.__ADO_HEADER_OVERLAY_INIT) {
    window.__ADO_HEADER_OVERLAY_INIT = true;

    window.addEventListener("scroll", apply, { passive: true });
    window.addEventListener("resize", apply);
    document.addEventListener("DOMContentLoaded", apply);

    document.addEventListener("shopify:section:load", function () { setTimeout(apply, 0); });
    document.addEventListener("shopify:section:unload", function () { setTimeout(apply, 0); });
    document.addEventListener("shopify:section:select", function () { setTimeout(apply, 0); });
    document.addEventListener("shopify:section:deselect", function () { setTimeout(apply, 0); });

    setTimeout(apply, 50);
  } else {
    setTimeout(apply, 0);
  }
})();
